module.exports = __webpack_public_path__ + "static/media/zocalo5.d74fa33a.jpg";